import styled from '@emotion/styled'

export const Alert = styled.div`
  position: fixed;
  bottom: 15px;
  right: 50%;
  min-width: 150px;
`
